import {combineReducers} from 'redux';
import authReducer from './authReducer';
import scheduleReducer from './scheduleReducer';
import errorReducer from "./errorReducer";
import accountReducer from "./accountReducer";

export default combineReducers({
    auth: authReducer,
    errors: errorReducer,
    schedule: scheduleReducer,
    account: accountReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.jsx